module.exports = __webpack_public_path__ + "static/media/pamain.cff37bbc.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain.woff2
// module id = ./src/assets/fonts/pamain.woff2
// module chunks = 6